import { Template } from '@/store/slices/api/physicianInterpretationApiSlice';

import { ReportLocationEnum } from './alert';

export interface ReportTemplate {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  organizationId: string;
  templateobject: TemplateObject;
  isExternalAccess: boolean;
  isVisible: boolean;
  deviceType: string;
  parentReportTemplate: ReportTemplate;
}

export interface TemplateObject {
  [ReportLocationEnum.Transmission]?: string | null;
  [ReportLocationEnum.BatteryStatus]?: string | null;
  [ReportLocationEnum.MonitoredValues]?: string | null;
  ALERT_PRESENTING?: string | null;
  IS_HEART_FAILURE?: boolean | null;
}

export interface FetchReportTemplatesRequest {
  reportId: number;
  deviceType: string;
  vendor: string;
  type: string;
}

export interface FetchOrgPhysicianTemplatesResponse {
  templates: Template[];
}

export interface FetchReportTemplatesResponse {
  templates: ReportTemplate[];
}

export interface ApplyReportTemplateRequest {
  reportId: number;
  templateId: string;
  parsedTemplateobject?: any;
}

export interface ReportTemplateResponse {
  template: TemplateObject;
}

export interface ReplaceReportTemplateRequest {
  reportId: number;
  templateId: string;
  parsedTemplateobject?: any;
}

export interface ReplaceReportTemplateResponse {
  applied: TemplateObject;
  removed: TemplateObject;
}

export const TemplateFieldMappings: Record<string, string> = {
  BATTERY_STATUS: 'Battery Status',
  MONITORED_VALUES: 'Monitored Values',
  ALERT_PRESENTING: 'Presenting Alert Card',
  TRANSMISSION: 'Technician Interpretation',
  IS_HEART_FAILURE: 'Report Name & Billing Codes'
};
